import React from 'react';
import {
  VStack,
  Box,
  Text,
} from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';
import useUnitData from '../../hooks/UseUnitData';
import useCostData from '../../hooks/UseCostData';
import FormCheckbox from '../FormCheckbox';
import CreditCard from '../Icons/CreditCard';
import DebitCard from '../Icons/DebitCard';
import ACH from '../Icons/ACH';
import { sizes } from '../../theme';
import FormRadioOption from '../FormRadioOption';

const PaymentMethodSelector = () => {
  const { setValue } = useFormContext();
  const { paymentType, savePaymentMode } = useWatch();
  const { data: { facility: { allowAchPaymentsE, alias } } } = useUnitData();
  const { data: {
    surchargePercent,
  } } = useCostData();
  const providerId = alias.split(':')[2];
  const options = [
    ...(providerId === 'se' && allowAchPaymentsE
      ? [{
        value: 'ach',
        icon: ACH,
        title: 'ACH/eCheck',
        description: 'Pay directly from your bank account with no extra fees.',
      }]
      : []),
    {
      value: 'debit',
      icon: DebitCard,
      title: 'Debit Card',
      description: 'Use your debit card for a quick payment.',
    },
    { value: 'credit',
      icon: CreditCard,
      title: 'Credit Card',
      description: surchargePercent
        ? `A ${surchargePercent}% processing fee applies to credit card payments.`
        : 'A processing fee may apply to credit card payments.' },
  ];
  const handleChange = (val) => {
    setValue('paymentType', val, { shouldDirty: true });
  };

  return (
    <Box
      w="100%"
      background="#FFFFFF"
      paddingTop={sizes._16px}
      paddingBottom={sizes._16px}
    >
      <Text
        fontWeight="700"
        fontFamily="Helvetica"
        fontSize={sizes._16px}
        lineHeight={sizes._20px}
        marginBottom={sizes._8px}
      >
        Select Preferred Payment Mode
      </Text>

      <Box border="2px solid #EAEAEA" borderRadius="6px" w="100%" background="#FFFFFF">
        <VStack spacing={0}>
          {options.map(({ value, icon, title, description }) => (
            <React.Fragment key={value}>
              <FormRadioOption
                icon={icon}
                value={value}
                name="paymentType"
                title={title}
                description={description}
                isSelected={paymentType === value}
                onChange={handleChange}
              />
              {value !== 'credit' && <Box w="100%" h="1px" borderTop="1px dashed #EAEAEA" />}
            </React.Fragment>
          ))}
        </VStack>
      </Box>

      <Box p={sizes._16px}>
        <FormCheckbox
          name="savePaymentMode"
          label="Save this mode for future payments"
          iconColor="yellow.400"
          isChecked={savePaymentMode}
        />
      </Box>

      <Box
        borderBottom="4px solid"
        borderColor="gray.lightBorder"
        marginBottom={sizes._8px}
      />
    </Box>
  );
};

export default PaymentMethodSelector;
